import React from "react";
import {
  CameraOutlined,
  GoogleDriveColored,
  ImageSquareOutlined,
  LinkOutlined,
  MicrophoneOutlined,
  OneDriveColored,
  UploadOutlined,
  VideoOutlined,
} from "@toddle-edu/ds-icons";
import classes from "./Attachments.scss";

export const Attachments = React.memo(({ testId }) => {
  return (
    <div data-test-id={testId} className={classes.iconContainer}>
      <ImageSquareOutlined testId="routine-templates-attachments-image" />
      <MicrophoneOutlined testId="routine-templates-attachments-audio" />
      <CameraOutlined testId="routine-templates-attachments-camera" />
      <VideoOutlined testId="routine-templates-attachments-video" />
      <LinkOutlined testId="routine-templates-attachments-link" />
      <UploadOutlined testId="routine-templates-attachments-upload" />
      <GoogleDriveColored
        size="x-small"
        testId="routine-templates-attachments-googledrive"
      />
      <OneDriveColored
        size="x-small"
        testId="routine-templates-attachments-onedrive"
      />
    </div>
  );
});
export default Attachments;
Attachments.displayName = "Attachments";
